<template>
  <form>
    <md-steppers :md-active-step.sync="active" md-vertical>
      <md-step
        id="first"
        md-label="Step 1"
        md-description="Before you begin"
        :md-done.sync="first"
        :md-editable="true"
      >
        <div class="mb-3">
          <form-group
            label="First Name"
            input-type="text"
            :validator-object="$v.userForm.first_name"
          ></form-group>
          <form-group
            label="Last Name"
            input-type="text"
            :validator-object="$v.userForm.last_name"
          ></form-group>
          <form-group
            label="Email"
            input-type="email"
            :validator-object="$v.userForm.email"
          ></form-group>
          <form-group
            label="Mobile Number"
            input-type="tel"
            :validator-object="$v.userForm.mobile_number"
          ></form-group>
          <form-group
            label="Company/Organisation"
            input-type="text"
            :validator-object="$v.userForm.induction_company"
          ></form-group>
        </div>
        <md-button class="md-primary mt-3" @click="setDone('first', 'second')">
          Continue
        </md-button>
      </md-step>
      <md-step
        id="second"
        md-label="Step 2"
        md-description="Safety Awareness"
        :md-done.sync="second"
        :md-editable="false"
        :class="{ disableStepper: !videoComplete }"
      >
        <img
          src="@/assets/img/induction-banner.jpg"
          class="img-fluid"
          alt="induction banner"
        />
        <md-button class="md-primary mt-3" @click="setDone('second', 'third')">
          Start Induction
        </md-button>
      </md-step>
      <md-step
        id="third"
        md-label="Step 3"
        md-description="WHS Safety Video"
        :md-done.sync="third"
        :md-editable="false"
        :class="{ disableStepper: !videoComplete }"
      >
        <div id="yt-embed-wrapper">
          <youtube
            ref="youtube"
            video-id="Rok2Ee4aK6k"
            :player-vars="inductionPlayerVars"
            nocookie
            @ended="inductionVidEnded"
          />
        </div>
        <p v-if="!videoComplete" class="md-helper-text my-1">
          Please watch the WHS video to continue.
        </p>
        <md-button
          class="md-primary"
          :disabled="!videoComplete"
          @click="setDone('third', 'fourth')"
        >
          Continue
        </md-button>
      </md-step>
      <md-step
        id="fourth"
        md-label="Step 4"
        md-description="Induction Qustionnaire"
        :md-done.sync="fourth"
        :md-editable="false"
        :class="{ disableStepper: !videoComplete }"
      >
        <div v-if="inductionComplete" id="induction-overlay"></div>
        <p>
          Click here for access to the
          <router-link to="/whsmanagement" target="_blank"
            >Work Health and Safety Management Plan</router-link
          >.
        </p>
        <div class="mb-3">
          <label>Have you visted the markets before?</label>
          <br />
          <md-radio v-model="$v.form.visitedBefore.$model" value="yes"
            >Yes</md-radio
          >
          <md-radio v-model="$v.form.visitedBefore.$model" value="no"
            >No</md-radio
          >
        </div>
        <div class="mb-3">
          <label>How often do you visit the Markets?</label>
          <br />
          <md-radio v-model="$v.form.visitFrequency.$model" value="first"
            >First time</md-radio
          >
          <md-radio v-model="$v.form.visitFrequency.$model" value="few"
            >Few times a week</md-radio
          >
          <md-radio v-model="$v.form.visitFrequency.$model" value="daily"
            >Daily</md-radio
          >
          <md-radio v-model="$v.form.visitFrequency.$model" value="weekly"
            >Weekly</md-radio
          >
          <md-radio v-model="$v.form.visitFrequency.$model" value="monthly"
            >Monthly</md-radio
          >
        </div>
        <div class="mb-3">
          <label>What markets do you visit regularly?</label>
          <br />
          <md-checkbox
            v-model="$v.form.marketsRegularlyVisited.$model"
            value="paddys_friday"
            >Paddy's Friday</md-checkbox
          >
          <md-checkbox
            v-model="$v.form.marketsRegularlyVisited.$model"
            value="paddys_saturday"
            >Paddy's Saturday</md-checkbox
          >
          <md-checkbox
            v-model="$v.form.marketsRegularlyVisited.$model"
            value="paddys_sunday"
            >Paddy's Sunday</md-checkbox
          >
          <md-checkbox
            v-model="$v.form.marketsRegularlyVisited.$model"
            value="produce_market"
            >Produce Market</md-checkbox
          >
          <md-checkbox
            v-model="$v.form.marketsRegularlyVisited.$model"
            value="growers_market"
            >Growers Market</md-checkbox
          >
          <md-checkbox
            v-model="$v.form.marketsRegularlyVisited.$model"
            value="flower_market"
            >Flower Market</md-checkbox
          >
          <md-checkbox
            v-model="$v.form.marketsRegularlyVisited.$model"
            value="none"
            >None</md-checkbox
          >
        </div>
        <div class="mb-3">
          <label>Do you buy at the Markets for your family?</label>
          <br />
          <md-radio v-model="$v.form.buyForFamily.$model" value="yes"
            >Yes</md-radio
          >
          <md-radio v-model="$v.form.buyForFamily.$model" value="no"
            >No</md-radio
          >
          <md-radio v-model="$v.form.buyForFamily.$model" value="na"
            >Not Applicable</md-radio
          >
        </div>
        <div class="mb-3">
          <label>Do you buy at the Markets for your business?</label>
          <br />
          <md-radio v-model="$v.form.buyForBusiness.$model" value="yes"
            >Yes</md-radio
          >
          <md-radio v-model="$v.form.buyForBusiness.$model" value="no"
            >No</md-radio
          >
          <md-radio v-model="$v.form.buyForBusiness.$model" value="na"
            >Not Applicable</md-radio
          >
        </div>
        <div class="mb-3">
          <label>Do you like to visit the Markets before 6am?</label>
          <br />
          <md-radio v-model="$v.form.visitBefore6am.$model" value="yes"
            >Yes</md-radio
          >
          <md-radio v-model="$v.form.visitBefore6am.$model" value="no"
            >No</md-radio
          >
          <md-radio v-model="$v.form.visitBefore6am.$model" value="na"
            >Not Applicable</md-radio
          >
        </div>
        <div class="mb-3">
          <p>
            All visitors to the markets must wear a Hi-Vis Vest, enclosed shoes
            and any other relevant PPE. Please be aware of forklifts and other
            heavy vehicles, and use the pedestrian walkways.
          </p>
          <label
            >Are you aware of the safety requirements for entering the
            markets?</label
          >
          <br />
          <md-radio v-model="$v.form.awareOfSafetyReqs.$model" value="yes"
            >Yes</md-radio
          >
          <md-radio v-model="$v.form.awareOfSafetyReqs.$model" value="no"
            >No</md-radio
          >
        </div>
        <div class="mb-3">
          <label
            >Did you know the Flower Market is now open to the public?</label
          >
          <br />
          <md-radio v-model="$v.form.awareOpenToPublic.$model" value="yes"
            >Yes</md-radio
          >
          <md-radio v-model="$v.form.awareOpenToPublic.$model" value="no"
            >No</md-radio
          >
          <br />
          <p>
            The Sydney Growers Market is open to the public Monday - Friday from
            6:00am <br />The Sydney Flower Market is open to the public on
            Saturdays only from 5:00am
          </p>
        </div>
        <md-button
          class="md-primary"
          :disabled="loading"
          @click="setDone('fourth', 'fifth')"
        >
          Submit Answers
        </md-button>
      </md-step>
      <md-step
        id="fifth"
        md-label="Induction Complete"
        :md-done.sync="fifth"
        :class="{ disableStepper: true }"
      >
        <div class="alert alert-success p-4 mb-4">
          <h3>Induction Complete</h3>
          <p class="mb-0">
            Sydney Markets thanks you for your participating! Please check your
            email for the induction results.
          </p>
        </div>
        <md-button href="https://www.sydneymarkets.com.au/" class="md-primary">
          Back to Sydney Markets
        </md-button>
      </md-step>
    </md-steppers>
  </form>
</template>
<script>
import ApiService from "@/services/api";
import { toastLaravelErrors } from "@/mixins";
import { email, required } from "vuelidate/lib/validators";
import FormGroup from "@/components/Forms/FormGroup.vue";

export default {
  name: "GuestInductionForm",
  components: { FormGroup },
  mixins: [toastLaravelErrors],
  data() {
    return {
      active: "first",
      first: false,
      second: false,
      third: false,
      fourth: false,
      fifth: false,
      loading: false,
      inductionComplete: false,

      videoComplete: false,
      inductionPlayerVars: {
        controls: 0,
        iv_load_policy: 3,
        modestbranding: 1
      },

      form: {
        visitedBefore: null,
        visitFrequency: null,
        marketsRegularlyVisited: [],
        buyForFamily: null,
        buyForBusiness: null,
        visitBefore6am: null,
        awareOfSafetyReqs: null,
        awareOpenToPublic: null
      },
      userForm: {
        first_name: "",
        last_name: "",
        email: "",
        induction_company: "",
        mobile_number: ""
      }
    };
  },
  validations: {
    form: {
      visitedBefore: { required },
      visitFrequency: { required },
      marketsRegularlyVisited: { required },
      buyForFamily: { required },
      buyForBusiness: { required },
      visitBefore6am: { required },
      awareOfSafetyReqs: { required },
      awareOpenToPublic: { required }
    },
    userForm: {
      first_name: { required },
      last_name: { required },
      email: { required, email },
      induction_company: {},
      mobile_number: {}
    }
  },
  methods: {
    async setDone(id, index) {
      if (id === "first") {
        if (!this.validateUserForm()) return;
      } else if (id === "fourth") {
        if (!(await this.submit())) return;
      }

      this[id] = true;
      if (index) {
        this.active = index;
      }
    },
    async submit() {
      if (!this.validate()) {
        this.$toast.error("Please answer all questions.");
        return;
      }

      if (this.loading) return;
      this.loading = true;

      // Submit induction
      let success = false;

      try {
        await ApiService.auth.setCSRF();
        await ApiService.induction.completeGuest(
          Object.assign({}, { responses: this.form }, this.userForm)
        );
        this.inductionComplete = true;
        success = true;
      } catch (error) {
        if (error.response.status === 422) {
          this.toastLaravelErrors(error);
        } else {
          this.$toast.error(error.response.data.message);
        }
      } finally {
        this.loading = false;
      }

      return success;
    },
    validate() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    validateUserForm() {
      this.$v.userForm.$touch();
      return !this.$v.userForm.$invalid;
    },
    inductionVidEnded() {
      this.videoComplete = true;

      // Same video but enable controls
      document.getElementById("yt-embed-wrapper").firstChild.src =
        "https://www.youtube-nocookie.com/embed/Rok2Ee4aK6k?iv_load_policy=3&modestbranding=1&enablejsapi=1&origin=http%3A%2F%2Flocalhost%3A8080&widgetid=3";
    }
  }
};
</script>
<style>
#induction-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.4);
  z-index: 10000;
  padding-top: 100%;
  margin: 0 24px 0 60px;
}

#yt-embed-wrapper iframe {
  width: 700px;
  height: 380px;
  border: none;
}

.disableStepper > button {
  pointer-events: none;
}
</style>
